import React, { useEffect, useState, useRef } from "react"
import logo from "../../assets/sc_logo.png"
import { FaAlignRight } from "react-icons/fa"
import { FaBars } from 'react-icons/fa'
import { Link } from "gatsby"


const Navbar = ({toggleSidebar}) => {
  // Section Below Added to determine when the page is scrolled to change background of Navbar from Transparent to White

  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  const [navBackground, setNavBackground] = useState(false)
  const navRef = useRef()
  const bgRef = useRef()
  navRef.current = navBackground
  bgRef.current = windowSize
  useEffect(() => {
    const handleScroll = () => {
      const show = window.scrollY > 20 // # 20 can be adjusted, the higher the number the further the scroll before changing background

      if (window.innerHeight >= 600) {
        if (navRef.current !== show) {
          setNavBackground(show)
        }  
      }
    }

    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });

      const bg = window.innerHeight <= 600
      if (bgRef.current !== bg) {
        setNavBackground(bg)
      } 
    }

    //add event listeners 
    document.addEventListener('scroll', handleScroll)
    window.addEventListener("resize", handleResize);
    //handleResize();
    return () => {
      document.removeEventListener('scroll', handleScroll)
      window.removeEventListener("resize", handleResize);
    }

  }, [])



  return (
    <nav id="header" class={`${navBackground?"fixed w-full z-30 top-0 bg-white shadow-2xl":"fixed w-full z-30 top-0"}`}> 
      
      <div class="max-w-7xl mx-auto flex flex-wrap items-center justify-between mt-0 py-4 px-6">
        <div class="flex items-center">
          <Link to="/">
              <img class="w-52 sclg:w-64 mb-1.5" src={logo} alt="StickChart Logo"  />
          </Link>
        </div>

        <div class="w-full flex-grow scmd:flex scmd:items-center scmd:w-auto hidden mt-0 scmd:mt-0 bg-white scmd:bg-transparent text-black scmd:p-0 z-20" id="nav-content">
          {/* Removed the PageLinks from this version of the NavBar */}
          {/* <PageLinks styleClass="uppercase list-reset list-none scmd:flex justify-end flex-1 items-center"></PageLinks> */}
        </div>
        
      </div>
      <hr class="border-b border-gray-100 opacity-25 my-0 py-0" />
    </nav>
  )
}

export default Navbar
